import {useEffect, useRef} from 'react'
import {useSearchParams} from 'react-router-dom'

import Style from './style'

import MainHeader from 'widget/MainHeader'
import Pagenation from 'widget/Pagenation'

import TStyle from 'shared/style/tableStyle'
import timestampCalculator from 'shared/lib/timestampCalculator'
import Search from 'widget/Search'
import TableLoading from 'shared/ui/TableLoading'
import SortableHeader from 'shared/ui/SortableHeader'
import useGetFranchiseUsageRightsStatusList from 'entity/franchise/useGetFranchiseUsageRightsStatusList'

const MyFranchiseMemberTicketList = () => {
	const [usageRightsStatusList, isLoading] =
		useGetFranchiseUsageRightsStatusList()

	const sizeList = ['medium', 'expand', 'expand', 'long', 'medium', 'long']
	const tableHeadList = [
		{label: '사용자 IDX', sortKey: 'userId'},
		{label: '이름', sortKey: 'userName'},
		{label: '닉네임', sortKey: 'userNickName'},
		{label: '매장 이용권 유형', sortKey: 'ticketName'},
		{label: '보유 수량', sortKey: 'count'},
		{label: '유효 기간', sortKey: 'expiresAt'},
	]

	return (
		<Style.Wrapper>
			<MainHeader>매장 이용권 보유 현황</MainHeader>

			<Search
				placeholder='IDX, 이름 및 닉네임으로 검색 가능'
				voucherTypeFilter={true}
			/>

			<Style.AreaDivTable>
				<TableLoading isLoading={isLoading}>
					<TStyle.TableDiv>
						<TStyle.TableRow $title>
							{tableHeadList.map((elem, index) => (
								<TStyle.Data key={index} $title $size={sizeList[index]}>
									<SortableHeader sortKey={elem.sortKey}>
										{elem.label}
									</SortableHeader>
								</TStyle.Data>
							))}
						</TStyle.TableRow>
						{usageRightsStatusList?.data?.items?.map((item, index) => (
							<TStyle.TableRow key={index} $odd={index % 2 === 1}>
								<TStyle.Data $size={sizeList[0]}>{item.userId}</TStyle.Data>
								<TStyle.Data $size={sizeList[1]}>{item.userName}</TStyle.Data>
								<TStyle.Data $size={sizeList[2]}>
									{item.userNickName}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[3]}>
									{item.ticketName ? item.ticketName : '-'}
								</TStyle.Data>
								<TStyle.Data $size={sizeList[4]}>{item.count}</TStyle.Data>
								<TStyle.Data $size={sizeList[5]}>
									{item.expiresAt ? timestampCalculator(item.expiresAt) : '-'}
								</TStyle.Data>
							</TStyle.TableRow>
						))}
					</TStyle.TableDiv>
				</TableLoading>
				<Pagenation maxPage={usageRightsStatusList?.data?.maxPage} />
			</Style.AreaDivTable>
		</Style.Wrapper>
	)
}

export default MyFranchiseMemberTicketList
